<template>
  <option :value="computed_value"><slot></slot></option>
</template>

<script>
import { slotText } from "../../utils";

export default {
  props: {
    value: {
      type: String,
      required: false,
    },
  },

  computed: {
    computed_value() {
      return this.value || slotText(this.$slots.default);
    },
  },
};
</script>
